import axiosPost from "./axiosPost";

export const RNHDivisionUpd = async (credentials, data) => {
    const body = {
        service: "RNHDivisionUpd",
        params: {
            rnhDivisionId: data?.id,
            rnhDivisionCod: data?.cod,
            rnhDivisionNombre: data?.name,
            rnhDivisionDescripcion: data?.desc,
            rnhDivisionVersion: data?.version,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
